import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModelParts2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 0H3a3 3 0 0 0 -3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3 -3V3a3 3 0 0 0 -3 -3Zm-4.5 22h-7v-2.15a3.47 3.47 0 0 0 2.35 -2.35H14V19a1 1 0 0 0 1 1h1.5ZM2 15.5V9h2.16l3.34 2.5v1.65a3.47 3.47 0 0 0 -2.35 2.35ZM18 18h-2v-2h2Zm-3 -4a1 1 0 0 0 -1 1v0.5h-2.15a3.47 3.47 0 0 0 -2.35 -2.35V12h7v2ZM9.5 4V2h6v2Zm-0.67 2h8.67v4H8.83L6.16 8Zm-0.33 9A1.5 1.5 0 1 1 7 16.5 1.5 1.5 0 0 1 8.5 15ZM19 14h-0.5v-2a1 1 0 0 0 1 -1V9H22v7h-2v-1a1 1 0 0 0 -1 -1Zm3 -11v4h-2.5V5a1 1 0 0 0 -1 -1h-1V2H21a1 1 0 0 1 1 1ZM3 2h4.5v2.5L4.16 7H2V3a1 1 0 0 1 1 -1ZM2 21v-3.5h3.15a3.47 3.47 0 0 0 2.35 2.35V22H3a1 1 0 0 1 -1 -1Zm19 1h-2.5v-2h0.5a1 1 0 0 0 1 -1v-1h2v3a1 1 0 0 1 -1 1Z",
		fill: "currentColor",
		strokeWidth: 1
	})
});
export { SvgModelParts2 as ReactComponent };
